import { Navigate, useLocation } from 'react-router-dom'
import { panelIdForPath } from '../permissions/panels'
import { usePanelAccess } from '../permissions/usePanelAccess'

/** Bloqueia rota se o utilizador não tiver `ver` no painel correspondente. */
export function RequirePanel({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()
  const { canView, isAdmin } = usePanelAccess()
  const panelId = panelIdForPath(pathname)

  if (!panelId) return <>{children}</>
  if (panelId === 'usuarios' && !isAdmin && !canView('usuarios')) {
    return <Navigate to="/" replace />
  }
  if (!canView(panelId)) {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}
